import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import ChapterDetail from "@/pages/detail/page";
import Special from "@/pages/special/page";
import SpecialArticlePage from "@/pages/special/article/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/detail/:id",
    element: <ChapterDetail />,
  },
  {
    path: "/special",
    element: <Special />,
  },
  {
    path: "/special/:slug",
    element: <SpecialArticlePage />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;